namespace TabAurous.Inventory {
    export interface SKUSplittingItemsForm {
        PartyId: Serenity.IntegerEditor;
        TransItemId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignId: Serenity.ServiceLookupEditor;
        DesignCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        StoneAmount: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        FancyCharges: AmountEditor;
        OtherCharges: AmountEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        HasBom: Serenity.BooleanEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.IntegerEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: Serenity.DecimalEditor;
        CostMethodId: Serenity.LookupEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: SKUSplittingBOMEditor;
        LaborDetails: SKUSplittingLaborEditor;
    }

    export class SKUSplittingItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SKUSplittingItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SKUSplittingItemsForm.init)  {
                SKUSplittingItemsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.LookupEditor;
                var w4 = CommonCategoryLookup;
                var w5 = CommonSubCategoryLookup;
                var w6 = CommonProductSizeLookup;
                var w7 = WeightEditor;
                var w8 = s.DecimalEditor;
                var w9 = AmountEditor;
                var w10 = s.BooleanEditor;
                var w11 = s.DateEditor;
                var w12 = s.ImageUploadEditor;
                var w13 = SKUSplittingBOMEditor;
                var w14 = SKUSplittingLaborEditor;

                Q.initFormType(SKUSplittingItemsForm, [
                    'PartyId', w0,
                    'TransItemId', w1,
                    'BagNo', w1,
                    'SKU', w1,
                    'LotNo', w1,
                    'CertificateNo', w1,
                    'RefNo', w1,
                    'ItemTypeId', w0,
                    'ProductId', w1,
                    'ProductCode', w1,
                    'ProductName', w1,
                    'DesignId', w2,
                    'DesignCode', w1,
                    'AttributeId', w1,
                    'ProductTypeId', w3,
                    'CategoryId', w4,
                    'SubCategoryId', w5,
                    'BrandId', w3,
                    'SuperTypeId', w3,
                    'CollectionId', w3,
                    'ProductSizeId', w6,
                    'Pieces', w0,
                    'Weight', w7,
                    'UnitRate', w8,
                    'StoneRate', w9,
                    'OtherRate', w9,
                    'StoneAmount', w8,
                    'UnitLabour', w8,
                    'FancyCharges', w9,
                    'OtherCharges', w9,
                    'NetAmount', w8,
                    'GrossAmount', w8,
                    'CCNetAmount', w8,
                    'CCGrossAmount', w8,
                    'HasBom', w10,
                    'Line_No', w1,
                    'HSN', w3,
                    'NetWeight', w7,
                    'DiamondPieces', w0,
                    'DiamondWeight', w7,
                    'StonePieces', w0,
                    'StoneWeight', w7,
                    'OtherPieces', w0,
                    'OtherWeight', w7,
                    'MetalAmount', w8,
                    'DiamondAmount', w8,
                    'OtherAmount', w8,
                    'CalcOnId', w0,
                    'UnitCost', w8,
                    'Discount', w8,
                    'WstPer', w8,
                    'WstWt', w8,
                    'CostMethodId', w3,
                    'RefTransItemId', w1,
                    'RefTransId', w1,
                    'Remark', w1,
                    'SpecialRemark', w1,
                    'UserDescription', w1,
                    'AckStatus', w0,
                    'DeliveryDate', w11,
                    'CompanyId', w0,
                    'BagStatus', w1,
                    'ImageName', w12,
                    'BOMDetails', w13,
                    'LaborDetails', w14
                ]);
            }
        }
    }
}
